<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-tab-group>
  <mat-tab label="Roles">
    <ng-template matTabContent>
      <app-admin-system-roles></app-admin-system-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="Scoring Model Roles">
    <ng-template matTabContent>
      <app-admin-scoring-model-roles></app-admin-scoring-model-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="Evaluation Roles">
    <ng-template matTabContent>
      <app-admin-evaluation-roles></app-admin-evaluation-roles>
    </ng-template>
  </mat-tab>
</mat-tab-group>
